module.exports = __webpack_public_path__ + "static/random-sculpture-mobile-5fa84a5cecdf9d20b63dde8724594958.png";